import * as React from 'react'
import { IStore } from 'reducers/index'
import { ThunkDispatch } from 'redux-thunk'
import { Action } from 'redux'
import CostColumnsData from 'views/job-costing/utils/CostColumnsData'
import { DataList } from 'components/select-advanced'
import { Input } from 'components/input/IndexAdvanced'
import { connect } from 'react-redux'
import { checkVendor } from 'actions/mdm'
import { resetParties } from 'actions/costRevenue'
import { formatDropDown } from 'views/job-costing/utils/CostAndRevenueHelpers'
import { sortElementByKey, uniqueArray } from 'utilities/util'
import { costAndRevErrorMessage } from '../../../views/job-costing/utils/models'
import { IParty } from 'reducers/cbl/models'
import { ICblDetail } from 'reducers/cbl/models';

const SIMPLE_ERROR = 'Field is required'
interface IState {
    partyData: any[];
    waitForVendors: boolean;
    error: string | null;
    partnerData: IParty[];
}
interface IMapDispatchToProps {
    checkVendor: (code: { beCode?: string; factCode?: string }, uniqueDropdownId: string) => Promise<any>;
    resetParties: () => Promise<void>;
}
interface IParams {
    target: string;
    data: any;
    className?: string;
    onUpdate: (targetField: string, evt:any, label?:string) => void;
    callbackDropdown: (field:any, data:any[], target:string) => string;
    errorList: any[];
    isCheckboxVisible?: boolean;
    onCheckboxSelect?: (e:boolean) => void;
    isDisabled?:boolean,
    dataListId:string,
    addOrEdit?: string,
}
interface IMapStateToProps {
   isFetchDataLoading: boolean;
   isFetchDataError: boolean;
   pendingError: string | null;
   mdm: any;
   customerMasterError: string | string[];
   customerMasterList:any[];
   vendors: any[];
   partners: any[];
   details: ICblDetail;
}
interface IProps extends IParams, IMapDispatchToProps, IMapStateToProps { }

export class _PartyComponent extends React.Component<IProps, IState> {
  // tslint:disable-next-line: no-unused-expression
  constructor(props:IProps){
    super(props)
    this.state = {
      waitForVendors: false,
      partyData:[],
      error: null,
      partnerData:[]
    }
  }
  public componentDidMount = () =>{
    if(this.props.customerMasterList.length > 0){
      this.initCustomerData()
    }
    if( this.props.vendors && this.props.vendors.length>0){
      this.parsePartyData()
    }
    if(this.props.data){
      this.findICB(this.props.data.party)
      this.getPartnersData()
    }
    if(this.props.partners){
      this.getPartnersData()
    }
  }
  public componentDidUpdate(props:any){
    if(props.customerMasterError !== this.props.customerMasterError){
      this.setState({
        partyData: [...this.state.partyData, {label: 'Others', value: 'others'}]
      })
    }
    if(props.isFetchDataError !== this.props.isFetchDataError && this.props.isFetchDataError){
      this.setState({error: 'Not found'})
      // this.resetAllparameters()
    }
    if(this.props.dataListId === this.props.mdm.uniqueId){
      if(props.mdm !== this.props.mdm && this.props.mdm && this.props.data.isOthers){
        if(this.props.mdm.factCode){
          this.setState({error: null})
          this.props.onUpdate('party', this.props.mdm.factCode)
          this.props.onUpdate('partyName', `${this.props.mdm.beCode} - ${this.props.mdm.factCode} - ${this.props.mdm.name}`)
          this.props.onUpdate('others', `${this.props.mdm.beCode} - ${this.props.mdm.factCode} - ${this.props.mdm.name}`)
          this.props.onUpdate('icbIndicator', this.findICB(this.props.mdm.factCode))
          this.props.onUpdate('partyDetails', `${this.props.mdm.countryCode}|${this.props.mdm.beCode}|${this.props.mdm.scvNumber}|${this.props.mdm.name}`)
        }else{
          this.setState({error: 'Not found'})
          this.resetAllparameters()
        }
      }
    }
    if(this.props.customerMasterList !== props.customerMasterList && this.props.customerMasterList.length > 0){
      this.initCustomerData()
    }
    if(this.props.data.party !== props.data.party || this.props.data.isOthers !== props.data.isOthers
      || this.props.data.others !== props.data.others || (this.props.data.id && this.props.data.id !== props.data.id) ){
      this.findICB(this.props.data.party)
      this.getPartnersData()
    }
    if(this.props.vendors !== props.vendors){
      this.parsePartyData()
    }
    if(this.props.partners !== props.partners){
      this.getPartnersData()
    }
  }
  public render() {
    return(
      <React.Fragment>
        <div className="col-20">
          {this.props.target === CostColumnsData.TYPES.COST && this.getPayToParty()}
          {!this.props.data.isOthers && this.props.target === CostColumnsData.TYPES.REVENUE && this.getBillToParty()}
          {this.props.data.isOthers &&
                    <Input label={'Please specify Country code + BECode'}
                      id={`${this.props.dataListId}-others`}
                      disabled={this.props.isDisabled}
                      className={this.props.className}
                      onChange={this.changeParty}
                      onKeyUp={() =>{
                        this.setState({error: null})
                      }}
                      onClose={() =>{
                        this.props.onUpdate('isOthers',false)
                        this.setState({
                          error: null
                        })
                        this.resetAllparameters()
                      }}
                      hasError={this.props.errorList.indexOf('party')>-1 || this.state.error!==null}
                      error={this.state.error ? this.state.error : (!this.props.isDisabled && this.props.errorList.indexOf('party')>-1 && !this.props.data.others) ? SIMPLE_ERROR:''}
                      placeholder="Please insert..."
                      showClose={true}
                      autocomplete={false}
                      value={this.props.data.others?this.props.data.others:''} type="text" />}
          {this.getCheckbox()}
        </div>
      </React.Fragment>
    )
  }

  public getPartyName = (val?:string) => {
    val = val ?? ''
    let partyName = ''
    if(this.props.data.isOthers){
      partyName = `${this.props.mdm.beCode} - ${this.props.mdm.factCode} - ${this.props.mdm.name}`
    }
    else{
      partyName = val +' - '+this.findName(val)
    }

    return partyName
  }
  public resetAllparameters = () =>{
    this.props.onUpdate('party','')
    this.props.onUpdate('partyName', '')
    this.props.onUpdate('icbIndicator', '-')
    this.props.onUpdate('partyDetails', '')
    this.props.onUpdate('others', '')
  }

  public returnFullDataList = () => {
    return [...this.state.partnerData, ...this.state.partyData]
  }

  public getPayToParty = () => {
    const data = this.returnFullDataList()
    let errorMsg = ''
    if(!this.props.isDisabled && (this.props.errorList.indexOf('party')>-1 || this.props.errorList.indexOf('icbIndicator')>-1)){
      if(this.props.addOrEdit === 'add'){
        errorMsg = !this.props.data.party ?SIMPLE_ERROR: ''
      }
      else{
        errorMsg = !this.props.data.party ? SIMPLE_ERROR : costAndRevErrorMessage.validationMsgCostandRev
      }
    }
    if(data?.length > 0 || this.state.waitForVendors){
      return (<DataList
        id={this.props.dataListId}
        className={this.props.className}
        label={'Pay to Party'}
        value={this.props.data.party}
        isDisabled={this.props.isDisabled}
        onChange={(e:any) =>{
          this.props.onUpdate('party', e)
          this.props.onUpdate('partyName', this.getPartyName(e))
          this.props.onUpdate('icbIndicator', this.findICB(e))}
        }
        hasError={(errorMsg?true:false)}
        error={errorMsg}
        data={data} />)
    }else if(data?.length === 0){
      return (<Input label={'Pay to Party'}
        className={this.props.className}
        id={this.props.dataListId}
        disabled={this.props.isDisabled}
        onChange={(e:any) =>{ this.props.onUpdate('party', e)}}
        error={SIMPLE_ERROR}
        hasError={this.props.errorList.indexOf('party')>-1}
        value={this.props.data.party} type="text" />)
    }
    return <div/>
  }
  public getBillToParty = () => {
    let errorMsg = ''
    if(!this.props.isDisabled && (this.props.errorList.indexOf('party')>-1 || this.props.errorList.indexOf('icbIndicator')>-1)){
      if(this.props.addOrEdit === 'add'){
        errorMsg = !this.props.data.party ? SIMPLE_ERROR: ''
      }
      else{
        errorMsg = !this.props.data.party ? SIMPLE_ERROR : costAndRevErrorMessage.validationMsgCostandRev
      }
    }
    const data = this.returnFullDataList()
    if(data?.length > 0){
      return <DataList
        id={this.props.dataListId}
        className={this.props.className}
        label={'Bill to Party'}
        value={this.props.data.party}
        isDisabled={this.props.isDisabled}
        onChange={(e:any) =>{
          if(e === 'others'){
            this.props.onUpdate('isOthers',true)
            this.props.onUpdate('party','')
            this.props.onUpdate('partyName','')
            this.props.onUpdate('partyDetails', '')
            this.props.onUpdate('icbIndicator','')
          }else{
            this.props.onUpdate('isOthers',false)
            this.props.onUpdate('party', e)
            this.props.onUpdate('partyName', this.getPartyName(e))
            this.props.onUpdate('icbIndicator', this.findICB(e))
          }
        }}
        hasError={(errorMsg?true:false)}
        error={errorMsg}
        data={data} />
    }
    else if(data?.length === 0){
      return <Input label={'Bill to Party'}
        className={this.props.className}
        disabled={this.props.isDisabled}
        id={this.props.dataListId}
        onChange={(e:any) =>{ this.props.onUpdate('party', e)}}
        hasError={this.props.errorList.indexOf('party')>-1}
        error={SIMPLE_ERROR}
        type="text" />
    }
    return <div/>
  }
  public findName = (e:string) => {
    const data = this.returnFullDataList()
    const resp:any = data.filter((child:any) => {
      return child.value === e
    })
    return resp[0].label? resp[0].label.split('- ')[1]: null
  }
  public findICB = (e:string) => {
    if(this.props.target === CostColumnsData.TYPES.COST){
      const resp:any = this.props.vendors.filter((child:any) => {
        return child.vendorCode === e
      })
      const c = resp[0] && resp[0].interCompany
      this.setPartyDetails(resp[0])
      return c && (c.toLowerCase() === 'y' || c.toLowerCase() === 'ic') ? 'IC':'-'
    }else{
      let f:any = []
      const filterAll = (key:string) =>{
        return this.props.customerMasterList.filter((el:any) => el[key] === e)
      }
      f = filterAll('customerCode')
      if(f[0] && f[0].interCompanyIC){
        this.setPartyDetails(f[0])
        return f[0].interCompanyIC
      }
      return '-'
    }
  }
  public setPartyDetails = (e:any) => {
    let t:any = ''
    if(e){
      if(this.props.target === CostColumnsData.TYPES.COST){
        t = `${e.country}|${e.vendorCode}|${e.scacCode}|${e.vendorName}`
      }else{
        t = `${e.country}|${e.beCode}|${e.scV_SCACCode}|${e.name}`
        if(e.customerCode){
          const country = e.customerCode? e.customerCode.substring(0,2):''
          t = `${country}|${e.becode}|${e.scvCode}|${e.customerName}`
        }
      }
    }
    this.props.onUpdate('partyDetails', t)
  }
  public changeParty = (e:any) => {
    const f = this.props.customerMasterList.filter((el:any) => el.becode === e)
    if(f[0]){
      const country = f[0].customerCode? f[0].customerCode.substring(0,2):''
      this.props.onUpdate('party',f[0].customerCode)
      this.props.onUpdate('partyName', this.getPartyName(f[0].customerName))
      this.props.onUpdate('icbIndicator', f[0].interCompanyIC)
      this.props.onUpdate('partyDetails', `${country}|${f[0].becode}|${f[0].scvCode}|${f[0].customerName}`)
      this.props.onUpdate('others','')
      this.props.onUpdate('isOthers',false)
    }else{
		this.setState({error: null})
		this.props.onUpdate('others', e),
		this.props.checkVendor({beCode:e}, this.props.dataListId)
	}
  }
  public parsePartyData = () => {
    if(this.props.target === CostColumnsData.TYPES.COST && this.props.vendors && this.props.vendors.length > 0){
      this.setState({waitForVendors: true})
      let party:any = formatDropDown(this.props.vendors, ['vendorCode','vendorName'],'vendorCode')
      party = sortElementByKey(party, 'label', false)
      const idList:any[] = []
      const oldConfig = party.filter((el:any) => {
        if(!idList.includes(el.value)){
          if(!el.interCompany || el.interCompany.toLowerCase() === 'n'){
            el.interCompany = '-'
          }
          idList.push(el.value)
          return el
        }
        return false
      })
      this.setState({
        partnerData: oldConfig
      })
    }
  }
  public initCustomerData = () =>{
    let party:any = formatDropDown(this.props.customerMasterList, ['customerCode','customerName'],'customerCode')
    party = sortElementByKey(party, 'label', false)
    let oldConfig:any = [...this.state.partyData,{label: 'Others', value: 'others'}]
    oldConfig = [...oldConfig, ...party, ]

    this.setState({
      partyData: oldConfig
    })
  }

  public getCheckbox = () => {
    if(this.props.isCheckboxVisible){
      return <label> {this.props.isCheckboxVisible}
        <input type="checkbox" name="single-party"
          key={'single-party-'+this.props.data.id}
          id="single-party"
          defaultChecked={this.props.data.isSameParty}
          onClick={(e:any) => {
            if(this.props.onCheckboxSelect){
              this.props.onCheckboxSelect(e.currentTarget.checked)
            }
          }}
        /> Same party for all jobs
      </label>
    }
    return <div/>
  }

  public getPartnersData = () => {	
	if(this.props.target === CostColumnsData.TYPES.REVENUE){
		let partners:any[] = [];
		const factCodeList:any[] = []
		let sortedPartners:any[] = []

		const filteredPartnersList = this.props.partners.filter((el:any) => {
			if(el.factCode && !factCodeList.includes(el.factCode)){
				factCodeList.push(el.factCode)
				return (el.partnerType !== 'PayToParty' && el.partnerType !== 'BillToParty' && el.partnerType !== 'Issuer' && el.partnerType !== 'Carrier') 
				&& el.factCode && el.showInDropdown === 'Y'
			}
			return false
		})

		const invoiceeParty = filteredPartnersList.filter((el:any) => el.partnerType === 'Invoicee');
		const shipperParty = filteredPartnersList.filter((el:any) => el.partnerType === 'Shipper');

		if(invoiceeParty.length > 0){
			const invoiceePartyFormatted = formatDropDown(invoiceeParty, ['factCode','name'],'factCode');
			if(shipperParty.length > 0 && invoiceeParty[0].factCode === shipperParty[0].factCode){
				partners = filteredPartnersList.filter((el:any) => el.partnerType !== 'Invoicee' && el.partnerType !== 'Shipper');									
			}else{
				partners = filteredPartnersList.filter((el:any) => el.partnerType !== 'Invoicee');
			}
			const formattedPartners:any = formatDropDown(partners, ['factCode','name'],'factCode');
			sortedPartners = sortElementByKey(formattedPartners, 'label', false);
			sortedPartners.unshift(invoiceePartyFormatted[0]);
		} else{
			if(this.props.data?.shipper){
				partners.push(this.props.data.shipper)
			}
			if(this.props.data?.consignee){
				partners.push(this.props.data.consignee)
			}
			if(partners.length > 0){
				const formattedPartners:any = formatDropDown(partners, ['factCode','name'],'factCode');
				sortedPartners = sortElementByKey(formattedPartners, 'label', false);
			}
		}

		this.setState({
			partnerData: uniqueArray(sortedPartners, 'value', 'label')
		})
	}	
  }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
  mdm: state.mdm.mdm,
  isFetchDataLoading: state.mdm.isFetchDataLoading,
  pendingError: state.mdm.pendingError,
  isFetchDataError: state.mdm.isFetchDataError,
  customerMasterError: state.materialMaster.isFetchDataPendingError,
  customerMasterList: state.materialMaster.customerMasterList,
  vendors: state.vendors.vendors,
  partners: state.partners.partners.result,
  details: state.cbl.details,
})

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
  checkVendor: (code: { beCode?: string; factCode?: string }, id:string) => dispatch(checkVendor(code, id)),
  resetParties: () => dispatch(resetParties())
})
export const PartyComponentNew = connect<IMapStateToProps, IMapDispatchToProps, unknown, IStore>(mapStateToProps, mapDispatchToProps)(_PartyComponent)